import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { uploadUserAvatar, removeUserAvatar } from '../../redux/actions';
import MockUser from '../../assets/img/avatar.jpg';
import MockUserInner from '../../assets/img/avatar_inner.jpg';
import {
  UserAvatar,
  UserChange,
  UserName,
  UserStatus,
  UserWrapper,
  RemoveAvatar,
} from './styles';

const mapDispatchToProps = dispatch => bindActionCreators({
  handleUploadAvatar: uploadUserAvatar,
  handleRemoveAvatar: removeUserAvatar,
}, dispatch);

@connect(null, mapDispatchToProps)
class UploadAvatar extends Component {
  static propTypes = {
    subscription: PropTypes.instanceOf(Object),
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    avatar: PropTypes.string,
    isInnerPage: PropTypes.bool,
    handleUploadAvatar: PropTypes.func,
    handleRemoveAvatar: PropTypes.func,
  };

  state = {
    uploadedAvatar: null,
  };

  handleFormSubmission = async evt => {
    const { target } = evt;
    const { handleUploadAvatar } = this.props;

    const avatar = target.files[0];
    const formData = new FormData();

    formData.append('avatar', avatar);

    handleUploadAvatar(formData);
  };

  render() {
    const { handleFormSubmission } = this;
    const { uploadedAvatar } = this.state;
    const { subscription, firstName, lastName, avatar, isInnerPage, handleRemoveAvatar } = this.props;

    const renderUserAvatar = () => {
      let userImage;

      if (avatar) {
        userImage = avatar.includes('http') ? avatar : `${process.env.AVATAR_URL}${avatar}`;
      }

      if (uploadedAvatar) {
        userImage = uploadedAvatar.includes('http') ? avatar : `${process.env.AVATAR_URL}${uploadedAvatar}`;
      }

      if (!avatar && !isInnerPage) {
        userImage = MockUser;
      }

      if (!avatar && isInnerPage) {
        userImage = MockUserInner;
      }

      return userImage;
    };

    const userStatus = subscription && subscription.name || 'Standard user';
    return (
      <Fragment>
        <UserAvatar isInnerPage={isInnerPage}>
          <img src={renderUserAvatar()} alt={firstName && lastName ? `${firstName} ${lastName}` : 'Unknown Guest'} />
        </UserAvatar>
        <UserWrapper>
          <UserStatus>{userStatus}</UserStatus>
          <UserName>{firstName || lastName ? `${firstName} ${lastName || 'Unknown'}` : 'Unknown Guest'}</UserName>
          <form onChange={handleFormSubmission}>
            <input type="file" id="uploadAvatar" hidden />
            <UserChange htmlFor="uploadAvatar">Change photo</UserChange>
            {avatar || uploadedAvatar ? <RemoveAvatar type="button" onClick={handleRemoveAvatar}>Remove photo</RemoveAvatar> : null}
          </form>
        </UserWrapper>
      </Fragment>
    );
  }
}

export default UploadAvatar;
